import { GOL, ARGOS, TU, BANK, AFS, HABITAT } from "./missions";

export const FIRST_NAME = "first_name";
export const LAST_NAME = "last_name";
export const TITLE = "title";
export const PASSWORD = "password";
export const CONFIRM_PASSWORD = "confirm_password";
export const MOBILE_NUMBER = "mobile_number";
export const TERMS_AND_CONDITIONS = "terms_and_conditions";
export const CONSENT_ALL = "consent_all";
export const GOL_MISSION = `preferences.${GOL}`;
export const ARGOS_MISSION = `preferences.${ARGOS}`;
export const TU_MISSION = `preferences.${TU}`;
export const BANK_MISSION = `preferences.${BANK}`;
export const AFS_MISSION = `preferences.${AFS}`;
export const HABITAT_MISSION = `preferences.${HABITAT}`;

// Error messages
export const PASSWORD_NOT_SAME = "Password cannot match current password";
export const PASSWORD_INVALID =
  "Your password does not meet our required criteria.";
export const PASSWORD_REQUIRED = "Password is required";
export const CONFIRM_PASSWORD_REQUIRED = "Confirm password is required";
export const PASSWORDS_NOT_MATCHING = "Passwords don't match";
export const FIRST_NAME_REQUIRED = "First name is required";
export const FIRST_NAME_INVALID = "First name is invalid";
export const LAST_NAME_REQUIRED = "Last name is required";
export const LAST_NAME_INVALID = "Last name is invalid";
export const NUMBER_INVALID = "Please provide a valid mobile number";
export const TERMS_REQUIRED = "You must agree to terms before proceeding";
